module.exports = __webpack_public_path__ + "img/homeIcon11.251e087f.png";